import type { FromModel } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const featureFlagModel = {
  id: Number,
  feature: String,
  percentage: Number,
  version: Number,
};

export const CmsFeatureFlagsModel = createModel({
  data: {
    featureFlags: [featureFlagModel],
  },
}).transform([featureFlagModel], (resp) => resp.data.featureFlags);

export type CmsFeatureFlag = FromModel<typeof featureFlagModel>;
export type CmsFeatureFlags = FromModel<typeof CmsFeatureFlagsModel>;
